module.exports = __webpack_public_path__ + "img/moon-50.70195d96.svg";